export default __webpack_public_path__ + "static/media/question.5b829186.svg";